export interface ApiError {
  code: string;
  description: string;
}

export class Result<T> {
  private constructor(
    private _value?: T,
    private _error?: ApiError
  ) {}

  public get Value(): T {
    if (this._error) {
      throw new Error(`Cannot access Value on failed Result. Error: ${this._error.description}`);
    }
    return this._value!;
  }

  public get Error(): ApiError {
    if (!this._error) {
      throw new Error('Cannot access Error on successful Result');
    }
    return this._error;
  }

  public get IsSuccess(): boolean {
    return this._error === undefined;
  }

  public get IsFailure(): boolean {
    return this._error !== undefined;
  }

  // Static factory methods
  public static Success<T>(value: T): Result<T> {
    return new Result<T>(value);
  }

  public static Failure<T>(code: string, description: string): Result<T> {
    return new Result<T>(undefined, { code, description });
  }

  public static FromApiError<T>(error: ApiError): Result<T> {
    return new Result<T>(undefined, error);
  }
}
